// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"M9-z"};